import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Layout from 'components/Layout'
import CategoriesComponent from 'components/DisplayCategories'
import ListFilters from 'components/DisplayCategories/ListFilters'
import Banner from 'components/Banner'

import { fetchFeatureFlags } from 'store/FeatureFlags/actions'
import {
  loadDisplayCategories,
  setDisplayCategoriesSortingMode,
} from 'store/DisplayCategories/actions'
import {
  loadGlobalItems,
  clearItemsIndexes,
} from 'store/Items/actions'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import { getOrgName } from 'store/AppState/selector'
import { getBannerIsOpen } from 'store/AppState/selector'
import { CATEGORY_BANNER_SETTINGS } from 'resources'

const DisplayCategories = () => {
  const dispatch = useDispatch()

  const venueUuid = useSelector(getCurrentVenueUuid)
  const orgName = useSelector(getOrgName)
  const { pathname } = useLocation()

  const isBannerOpen = useSelector((state) =>
    getBannerIsOpen(state, pathname.replace('/', ''))
  )

  useEffect(() => {
    dispatch(fetchFeatureFlags(venueUuid, orgName))
    dispatch(loadDisplayCategories({ venueUuid }))
    dispatch(loadGlobalItems(venueUuid))

    return () => {
      dispatch(clearItemsIndexes())
      dispatch(setDisplayCategoriesSortingMode(false))
    }
    // eslint-disable-next-line
  }, [venueUuid])

  return (
    <>
      <Banner bannerSettings={CATEGORY_BANNER_SETTINGS}>
        <Layout
          isSidebar
          isBanner={isBannerOpen}
          title="Categories"
          navbarContent={<ListFilters />}
          mainContent={<CategoriesComponent />}
        />
      </Banner>
    </>
  )
}

export default DisplayCategories
